import React from 'react';
import './MenuButton.scss';
import {NavLink} from "react-router-dom";

interface MenuButtonProps {
    children: React.JSX.Element,
    title: string,
    link: string,
    onClick?: () => void,
}


const MenuButton = ({children, title, link, onClick}: MenuButtonProps) => {
    return (
        <NavLink to={link} end onClick={onClick}
                 className={({isActive}) => `MenuButton ${isActive ? 'active' : ''}`}>
            {children}
            <span>{title}</span>
        </NavLink>
    );
};

export default MenuButton;
